module finadai.app.admin.search {
    import ProxyRecord = models.http.responses.ProxyRecord;
    export var NAME = "finadai.app.admin.search"

    function AdminSearchController(customersService: services.CustomersService,
                                   whoIAm: models.User, $rootScope, $scope,
                                   notify, confirm, $mdDialog: ng.material.IDialogService,
                                   $state: ng.ui.IStateService, negotiationsService: services.NegotiationsService,
                                   proxifier, $q: ng.IQService, authService: services.AuthService) {
        $scope.formData = {};
        $scope.negotiationData = {};
        $scope.searchComplete = false;
        $scope.searchingInProgress = false;
        $scope.sendingNegotiation = false;
        $scope.messageCustomer = "";

        $scope.plazos = [
            {id: 3, name: 'Semana'},
            {id: 4, name: 'Catorcena'},
            {id: 1, name: 'Mes'}
        ];
        let msgCustomer = "";
        $scope.canSearchForCustomer = whoIAm.operations.indexOf('admin_search_customer') >= 0;
        $scope.searchCustomerData = (form) => {
            if (form.$valid) {
                $scope.searchComplete = false;
                $scope.searchingInProgress = true;
                customersService.proxyGetCustomer({customer_number: $scope.formData.customer_number})
                    .then(function (response) {
                        $scope.search_customer = response.data;
                        if ($scope.search_customer.Data.PrimerNombre !== undefined) {
                            msgCustomer = "RFC: " + $scope.search_customer.Data.RFC + " <br /> Nombre Completo: " + $scope.search_customer.Data.PrimerNombre + " " + $scope.search_customer.Data.SegundoNombre + " " + $scope.search_customer.Data.ApellidoPaterno + " " + $scope.search_customer.Data.ApellidoMaterno;
                            msgCustomer += "<hr />";
                        } else {
                            msgCustomer = "No se encontro acreditado";
                        }
                    }, function () {
                        $scope.searchingInProgress = false;
                    }).then(function () {
                    customersService.proxySearchCredit({customer_number: $scope.formData.customer_number}).then(function (response) {
                        let $credit_info = "";
                        $scope.search_creditInfo = response.data;
                        $scope.search_creditInfo = angular.isArray($scope.search_creditInfo.Data.Saldo) ? $scope.search_creditInfo.Data.Saldo : [$scope.search_creditInfo.Data.Saldo];
                        angular.forEach($scope.search_creditInfo, function (value, key) {
                            $credit_info += $scope.displayFields(value);
                        });
                        msgCustomer += $credit_info;
                        $scope.messageCustomer = msgCustomer;
                        $scope.searchComplete = true;
                        $scope.searchingInProgress = false;
                    }, function () {
                        $scope.searchComplete = true;
                    });
                })
            }
        };
        $scope.displayFields = (value) => {
            var output = '<ul>';
            angular.forEach(value, (value, key) => {
                output += '<li>' + key + ": " + value + '</li>';
            });
            output += '</ul>';
            output += '<hr />';
            return output
        }
    }

    export function run() {
        var search = angular.module(NAME, [])
        search.controller("AdminSearchController", AdminSearchController)
    }
}
finadai.app.admin.search.run();